export default {
  props: {
    menu: Object
  },

  created() {
    this.getTeachData();
  },

  data() {
    return {
      teachData: []
    };
  },

  methods: {
    async getTeachData() {
      const teachData = await this.$http.getTeachData({
        num: this.menu.num
      });
      this.teachData = teachData;
      console.log("数据模块", teachData);
    }

  }
};